import { BaseVisualization } from '../base/base-visualization-component'
import angular from 'angular'
import startCase from 'lodash/startCase'

//TODO: rename class to AFMetricsChartComponent
export class SideDataChartComponent extends BaseVisualization {
 static config = {
  selector: 'afMetricsChart',
  controller: SideDataChartComponent,
  bindings: BaseVisualization.config.bindings,
  template: `
            <div ng-repeat="metrics in $ctrl.vizData" class="mw-twitter-metric-container" ng-if="!$ctrl.isLoading && !$ctrl.isObjEmpty($ctrl.vizData)">
                <span class="mw-twitter-metric-key"> <b> {{metrics.value | mwTruncateNumber}} </b> </span>
                <br> <div class="ssa__visualization--metrics-toolgroup"><span translate>{{ $ctrl.translationKey[metrics.key].title }}</span><flux-infotip translate>{{ $ctrl.translationKey[metrics.key].tooltip }}</flux-infotip><br>
                <md-tooltip>{{metrics.value | number}}</md-tooltip>
            </div>
        `,
 }

 /**
  * Translation keys must be manually added here for any
  * backend data view that uses this chart. Since the
  * data is dynamic (from backend) and not constant.
  */
 private translationKey = {
  Impressions: {
   title: 'explore__visualizations--key-metrics-impressions',
   tooltip: 'explore__visualizations--key-metrics-for-twitter--info-impressions',
  },
  Users: {
   title: 'Users',
   tooltip: 'explore__visualizations--key-metrics-for-twitter--info-users',
  },
  Mentions: {
   title: 'explore__visualizations--key-metrics-mentions',
   tooltip: 'explore__visualizations--key-metrics-for-twitter--info-mentions',
  },
  Reach: {
   title: 'Reach',
   tooltip: 'explore__visualizations--key-metrics-for-twitter--info-reach',
  },
 }

 $onChanges(changes) {
  if (this.hasChanges(changes.visualizationMetaData)) {
   this.setMetaData(changes.visualizationMetaData.currentValue)
  }
  if (changes.vizData && typeof changes.vizData.currentValue !== 'undefined') {
   // update/build data to be displayed in UI
   let payloadData = changes.vizData.currentValue
   if (!this.isObjEmpty(payloadData)) {
    this.updateData(payloadData)
   }
  } else {
   this.visualizationData = {}
   this.visualizationDataArray = []
  }
 }

 /**
  * Method to format/shape the spline & metrics data so that it can be
  * displayed in it's respective component directive.
  * @param payload object containing the metrics and spline data
  */
 updateData(payload) {
  let donutData = []
  angular.copy(payload.data.all, donutData)
  this.vizData = donutData.map(x => {
   x.code = startCase(x.key)
   return x
  })
 }
}
